import React from 'react';
import ColumnRenderer from '@/util/ColumnRenderer';
import ButtonWithClose from '@/components/ButtonWithClose';
import ColumnsSelector from '@/components/ColumnsSelector';
import { JoinModeProps } from '@/components/modals/ModalJoin/types';
import ColumnName from '@/util/ColumnName';
import ModalLoading from '@/components/modals/ModalLoading';
import Column from '@/util/Column';
import { INT, STRING } from '@/util/ColumnType';

export type CombineRowsProps = Pick<
  JoinModeProps,
  'state' | 'columns' | 'userInteraction' | 'usedAliases'
>;

export const CombineRows: React.FC<CombineRowsProps> = ({
  state,
  columns,
  userInteraction,
  usedAliases,
}) => {
  const buildColumnRenderer = (
    event: 'selectLhs' | 'selectRhs',
    _columns: typeof columns,
    _usedAliases: typeof usedAliases,
  ) => {
    const extractType = (columnName: ColumnName) => {
      const lhsColumn = _columns.find((c) => c.name().equals(columnName));
      return lhsColumn?.type?.();
    };
    const renderer = new ColumnRenderer(
      event,
      userInteraction,
      _usedAliases,
      // @ts-expect-error: types mismatch. Likely will be solved after we get rid of ColumnRenderer
      extractType,
    );
    return (
      <ColumnsSelector
        values={_columns.map((c) => c.name())}
        renderer={renderer}
      />
    );
  };

  const columnFilter = (c: Column) => {
    const columnType = c.type().type();
    const selectedColumnType = state.selectedType.type();

    if (columnType === selectedColumnType) return true;
    if (columnType === INT && selectedColumnType === STRING) return true;
    if (columnType === STRING && selectedColumnType === INT) return true;
    return false;
  };

  const lhsOptions = state.selectedLhs ? (
    <button
      type="button"
      className="btn btn-outline-dark full-width"
      onClick={userInteraction({ section: 'deselectLhs' })}
    >
      {state.selectedLhs.name()}
    </button>
  ) : (
    buildColumnRenderer(
      'selectLhs',
      state.selectedType ? columns.filter(columnFilter) : columns,
      usedAliases,
    )
  );

  const rhsOptions = !state.tableColumns ? (
    <ModalLoading />
  ) : state.selectedRhs ? (
    <button
      type="button"
      className="btn btn-outline-dark full-width"
      onClick={userInteraction({ section: 'deselectRhs' })}
    >
      {state.selectedRhs.name()}
    </button>
  ) : (
    buildColumnRenderer(
      'selectRhs',
      state.selectedType
        ? state.tableColumns.filter(columnFilter)
        : state.tableColumns,
      {
        ' ': state.selectedTov,
      },
    )
  );

  return (
    <div className="margin-bottom">
      <div className="margin-bottom">
        <ButtonWithClose
          userInteraction={userInteraction}
          data={{ section: 'deselectTable' }}
          text={state.selectedTov?.name?.()}
        />
      </div>
      <p>
        <b>Combine rows based on</b>
      </p>
      <div className="customJoinWizardCols">
        <div>{lhsOptions}</div>
        <span className="customJoinWizardColsEquals">=</span>
        <div>{rhsOptions}</div>
      </div>
    </div>
  );
};
